'use strict';

function formatTime(timeRemaining, translations, showDay = false) {
    const days = timeRemaining.days.toString().slice(-2) + `${translations.days}`;
    const hours = ('0' + timeRemaining.hours).slice(-2) + `${translations.hours}`;
    const minutes = ('0' + timeRemaining.minutes).slice(-2) + `${translations.minutes}`;
    const seconds = ('0' + timeRemaining.seconds).slice(-2) + `${translations.seconds}`;
    return `${(showDay || timeRemaining.days > 0) ? days : ''} ${hours} ${minutes} ${seconds}`;
}

function formatTimeColon(timeRemaining) {
    const totalHours = timeRemaining.days * 24 + timeRemaining.hours;
    const hours = ('0' + totalHours).slice(-2);
    const minutes = ('0' + timeRemaining.minutes).slice(-2);
    const seconds = ('0' + timeRemaining.seconds).slice(-2);
    return `${hours}:${minutes}:${seconds}`;
}

function getTimeRemaining(endTime) {
    const now = Date.parse(new Date());
    const timeDifference = endTime - now;

    return {
        total: timeDifference,
        days: Math.floor(timeDifference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((timeDifference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((timeDifference / 1000 / 60) % 60),
        seconds: Math.floor((timeDifference / 1000) % 60)
    };
}

function initCountdown(countdown) {
    if (countdown.offsetParent === null) {
        return;
    }
    if (countdown.dataset.countdownInitialized) {
        return;
    }
    countdown.dataset.countdownInitialized = 'true';
    try {
        const countdownTimerDisplay = countdown.querySelector('.js-countdown-timer-display');
        countdownTimerDisplay.classList.remove('placeholder');
        const defaultConfig = { countdownTargetDateAndTime: '', cutOffTime: '', hideOnTimerEnds: false };
        const configWidget = JSON.parse(countdown.getAttribute('data-countdown-config')) || defaultConfig;
        const config = Object.assign({}, defaultConfig, configWidget);
        const endTime = config.countdownTargetDateAndTime ? Date.parse(config.countdownTargetDateAndTime) : config.cutOffTime;
        const translations = JSON.parse(countdownTimerDisplay.getAttribute('data-translations')) || {};
        let intervalId;
        const updateCountdownDisplay = () => {
            const timeRemaining = getTimeRemaining(endTime);
            if (timeRemaining.total < 0) {
                clearInterval(intervalId);
                if (config.hideOnTimerEnds) {
                    const removalTarget = countdown.closest('.js-flash-sale-wrapper') || countdown;
                    removalTarget.remove();
                }
            } else {
                countdownTimerDisplay.innerText = config.colonFormat
                    ? formatTimeColon(timeRemaining)
                    : `${formatTime(timeRemaining, translations, !!config.countdownTargetDateAndTime)}`;
            }
        };
        updateCountdownDisplay();
        intervalId = setInterval(updateCountdownDisplay, 1000);
    } catch (e) {
        console.error(e);
    }
}

function initAllCountdowns() {
    document.querySelectorAll('.js-countdown').forEach(initCountdown);
}

function reinitCountdownsOnCheckoutStageChange() {
    const checkoutMain = document.getElementById('checkout-main');
    if (!checkoutMain) {
        return;
    }
    new MutationObserver(initAllCountdowns)
        .observe(checkoutMain, { attributes: true, attributeFilter: ['data-checkout-stage'] });
}

module.exports = function () {
    initAllCountdowns();

    document.addEventListener('search:filtered', initAllCountdowns);
    document.addEventListener('search:pagination-changed', initAllCountdowns);
    document.addEventListener('pdp:productVariationAjaxDone', initAllCountdowns);
    reinitCountdownsOnCheckoutStageChange();
};

